import { EventName } from "@homeinstead/shared";

type CustomerServiceFormSubmissionResult =
  | "exception-error"
  | "server-error"
  | "success"
  | "validation-error";

const CustomerServiceFormSubmitEvent = ({
  franchiseNumber,
  result,
}: {
  franchiseNumber: string;
  result: CustomerServiceFormSubmissionResult;
}) => ({
  event: EventName.CUSTOMER_SERVICE_FORM_SUBMIT,
  form_id: "customer-service-form",
  form_submission_intent: "customer-service",
  form_submission_result: result,
  franchise_number: franchiseNumber,
  job_id: "",
});

export { CustomerServiceFormSubmitEvent };
